module.exports = __webpack_public_path__ + "img/addContact.11c70d19.png";